/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/
import styled from "styled-components";

import {WealthyEnv} from "helpers";
import {colors} from "nxtconstants";

const loadingGif = `url(${WealthyEnv.HOMEPAGE_CDN_URL}/invest/search-loading.gif)`;

const wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 6rem 6.6rem;

  @media (max-width: 1220px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  @media (max-width: 768px) {
    padding-top: 4rem;
    padding-bottom: 0;
    margin-top: 8rem;
  }
`;

const title = styled.h2`
  font-size: 4.2rem;
  font-family: 'Playfair Display', serif;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2.6rem;
  }
`;

const infoline = styled.p`
  font-size: 1.6rem;
  color: ${colors.textGray};
  text-align: center;
  padding: 1rem 0;
  line-height: 1.6;
  font-family: Lato;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const error = styled.p`
  color: ${colors.razzmatazz};
  font-size: 1.2rem;
  text-align: left;
  font-weight: bolder;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const loader = styled.div`
  height: 100%;
  background-image: ${loadingGif};
  background-size: 50px 50px;
  background-position: center;
  background-repeat: no-repeat;
`;

const button = styled.button`
  font-size: 1.8rem;
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 1.3rem 4.4rem;
  display: inline-block;
  border-radius: 100px;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  border: 0;

  span {
    color: ${colors.rajah};
  }

  &:hover {
    transform: translateY(-4px);
  }

  @media (max-width: 576px) {
    font-size: 1.6rem;
    display: block;
    text-align: center;
  }
`;

export {
  wrapper,
  title,
  infoline,
  error,
  loader,
  button
};
